/**
 * @file BootstrapModalのアクティベーション
 */
'use strict'

/**
 * @classname ActivateBootstrapModal
 * 
 * 他のファイルで確実にBootstrapModalのインスタンスを取得するために
 * このファイルでまとめてアクティベーションし、
 * BasicInitialize.jsで各モジュールより先に適用する。
 */
export default class ActivateBootstrapModal {
	/**
	 * @constructor
	 */
	constructor() {
		console.log(`ActivateBootstrapModal.constructor`)
		this.activate()
	}


	/**
	 * アクティベーション
	 *
	 * @memberof BtnDeleteFilter
	 */
	activate() {
		console.log(`ActivateBootstrapModal.activate`)
		new bootstrap.Modal(document.getElementById('modal-saved-filters'))
		new bootstrap.Modal(document.getElementById('modal-complete-filter-delete'))
	}
 }
